/* tslint:disable */
/* eslint-disable */
/**
 * Marco Email Parser API
 * Marco Email Parser API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateFlightCreditRequest
 */
export interface CreateFlightCreditRequest {
    /**
     * IATA airline code (e.g. UA, DL, AA)
     * @type {string}
     * @memberof CreateFlightCreditRequest
     */
    airline?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateFlightCreditRequest
     */
    creditType: CreateFlightCreditRequestCreditTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof CreateFlightCreditRequest
     */
    creditNumber?: string | null;
    /**
     * Credit face value
     * @type {number}
     * @memberof CreateFlightCreditRequest
     */
    amount: number;
    /**
     * ISO 4217 currency code
     * @type {string}
     * @memberof CreateFlightCreditRequest
     */
    currency?: string;
    /**
     * 
     * @type {Date}
     * @memberof CreateFlightCreditRequest
     */
    expirationDate?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof CreateFlightCreditRequest
     */
    originalConfirmationNumber?: string | null;
    /**
     * Optional notes about this credit
     * @type {string}
     * @memberof CreateFlightCreditRequest
     */
    notes?: string | null;
}


/**
 * @export
 */
export const CreateFlightCreditRequestCreditTypeEnum = {
    FlightCredit: 'flight_credit',
    Ecredit: 'ecredit',
    TripCredit: 'trip_credit',
    TravelFund: 'travel_fund',
    WalletCredit: 'wallet_credit',
    TravelBankCredit: 'travel_bank_credit',
    ElectronicTravelCertificate: 'electronic_travel_certificate',
    Voucher: 'voucher',
    Refund: 'refund'
} as const;
export type CreateFlightCreditRequestCreditTypeEnum = typeof CreateFlightCreditRequestCreditTypeEnum[keyof typeof CreateFlightCreditRequestCreditTypeEnum];


/**
 * Check if a given object implements the CreateFlightCreditRequest interface.
 */
export function instanceOfCreateFlightCreditRequest(value: object): value is CreateFlightCreditRequest {
    if (!('creditType' in value) || value['creditType'] === undefined) return false;
    if (!('amount' in value) || value['amount'] === undefined) return false;
    return true;
}

export function CreateFlightCreditRequestFromJSON(json: any): CreateFlightCreditRequest {
    return CreateFlightCreditRequestFromJSONTyped(json, false);
}

export function CreateFlightCreditRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateFlightCreditRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'airline': json['airline'] == null ? undefined : json['airline'],
        'creditType': json['credit_type'],
        'creditNumber': json['credit_number'] == null ? undefined : json['credit_number'],
        'amount': json['amount'],
        'currency': json['currency'] == null ? undefined : json['currency'],
        'expirationDate': json['expiration_date'] == null ? undefined : (new Date(json['expiration_date'])),
        'originalConfirmationNumber': json['original_confirmation_number'] == null ? undefined : json['original_confirmation_number'],
        'notes': json['notes'] == null ? undefined : json['notes'],
    };
}

export function CreateFlightCreditRequestToJSON(json: any): CreateFlightCreditRequest {
    return CreateFlightCreditRequestToJSONTyped(json, false);
}

export function CreateFlightCreditRequestToJSONTyped(value?: CreateFlightCreditRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'airline': value['airline'],
        'credit_type': value['creditType'],
        'credit_number': value['creditNumber'],
        'amount': value['amount'],
        'currency': value['currency'],
        'expiration_date': value['expirationDate'] == null ? value['expirationDate'] : value['expirationDate'].toISOString().substring(0,10),
        'original_confirmation_number': value['originalConfirmationNumber'],
        'notes': value['notes'],
    };
}

